import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { Job, Project, ProjectSearchCriteria } from '@app/shared';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { AppState, selectProjectState, selectTeamState, selectJobState } from '@app/store/app.states';
import { JobActionTypes, CopyFullJob } from '@app/store/actions/job.actions';
import { ProjectActionTypes, ValidateProject, GetProjects } from '@app/store/actions/project.actions';
// import { listTransition } from '@app/core/animations/list-animations';

@Component({
  selector: 'app-copy-dialog',
  templateUrl: './copy-dialog.component.html',
  styleUrls: ['./copy-dialog.component.scss'],
  // animations: [ listTransition ]
})
export class CopyDialogComponent implements OnInit {

  action:string;
  notifyFormGroup: FormGroup;
  success:boolean = false;
  includeOffers:boolean = false;
  includeTeams:boolean = false;
  selectedJob:Job;
  regionName:string = '';

  // private JOB_SUFFIX = "_copy";
  private projects$:Project[];
  private storeProjectSubscription:Subscription;
  private jobStoreSubscription:Subscription;
  private getProjectState$: Observable<any>;
  private getJobState$: Observable<any>;

  public projectActionTypes = ProjectActionTypes;

  @ViewChild('notifyForm') notifyForm;
  @ViewChild('wizard') wizard: ElementRef;

  project:Project;
  jobs:Job[];
  options: FormGroup;
  isCodeValid:boolean = true;
  searchCriteria:ProjectSearchCriteria = new ProjectSearchCriteria();

  constructor(
    public dialogRef: MatDialogRef<CopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    public snackBar: MatSnackBar,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) {

    this.getProjectState$ = this.store.select(selectProjectState);
    this.getJobState$ = this.store.select(selectJobState);

    this.jobs = data.jobs;
    this.selectedJob = data.job;
    this.project = data.project;

    // set the action
    this.action = data.action;

    this.options = new FormGroup({
      code : new FormControl('',Validators.compose([
      		this.validateCode.bind(this),
      		Validators.required
      	])),
      name : new FormControl('',[Validators.required]),
      startDateInput : new FormControl(''),
      endDateInput : new FormControl(''),
      startDate : new FormControl(''),
      endDate : new FormControl(''),
      includeOffers : new FormControl(false),
      includeTeams: new FormControl(false),
    });  
    
    this.storeProjectSubscription = this.getProjectState$.subscribe((state) => {
      this.projects$ = state.projects;

      if(state.searchCriteria)
        this.searchCriteria = state.searchCriteria;

      // If we have validated the project code and it fails then we need to reset the value so the
      // validation triggers again
      if(state.errorStatus && state.actionType === ProjectActionTypes.VALIDATE_PROJECT_FAILURE){
        this.initialiseCodeValidation(false)
      };
      if(state.successStatus && state.actionType === ProjectActionTypes.VALIDATE_PROJECT_SUCCESS){
        this.initialiseCodeValidation(true)
      };


    });
 
    this.jobStoreSubscription = this.getJobState$.subscribe((state) => {
      if(state.actionType === JobActionTypes.COPY_FULL_JOB_SUCCESS){

        // if we are editing we just close the modal and show the snackbar
        // if(this.dialogRef.componentInstance.data.action === ProjectActionTypes.COPY_FULL_JOB){
          this.closeCopy();
          this.snackBar.open(state.successStatus.msg,'',{
              duration: 2000,
          });
          // this.searchProjects();
          // setTimeout(_ => this.loadProjects(),1000)
        // }
  
      };
    });

    // this.jobs.forEach(job => {
      
    //   // let checked = (this.selectedJob && job.uuid === this.selectedJob.uuid)?true:false;
    //   let checked = true;
    //   const fc = new FormControl(checked);
    //   const fn = new FormControl(this.getRegionName(job),[this.dynamicRequiredValidator.bind(this)]);
    //   this.options.addControl(`${job.uuid}_cb`,fc);
    //   this.options.addControl(`${job.uuid}_name`,fn);
    // })
  }

  ngOnInit() { }

  private initialiseCodeValidation(valid:boolean):void{
    this.isCodeValid = valid;
    const control = this.options.get('code');
    const val = control.value;
    control.setValue(val)
  }

  private closeCopy():void{
    this.dialogRef.close();
  }
  
  /*
    Custom form validation for the project code
  */
validateCode(fc: FormControl){
  if(this.options != undefined) {
    if(!this.isCodeValid){
      return {
        validateCode: {
          valid:false
        }
      };
    }
    if(this.project.code === this.options.value.code) {
      this.isCodeValid = false;
        return {
          validateCode: {
            valid:false
          }
        };
    }
    return null;
  }
}
  // public dynamicRequiredValidator(control: FormControl):any{
  //   var theFieldName = this.getControlName(control);
  //   if(theFieldName){
  //     let uuid = theFieldName.replace('_name','_cb');
  //     let cbControl = this.options.controls[uuid];
  //     // if the checkbox is checked then set requred
  //     if(cbControl.value){
  //       return Validators.required;
  //     }
  //   }
    
  //   return {};
  // }

  // canSubmit():boolean{
  //   // get the checkbox items make sure one is checked
  //   let itemChecked = false;
  //   for(let i = 0; i< this.jobs.length; i++){
  //     let job = this.jobs[i];
  //     const cb = `${job.uuid}_cb`;
  //     if(this.options.controls[cb].value){
  //       itemChecked = true;
  //       break;;
  //     }
  //   }
    
  //   return (itemChecked && this.options.valid);
  // }
  // getRowClass(job:Job):string{
  //   let cls = "name-holder";
  //   const name = `${job.uuid}_cb`;
    
  //   if(this.options.controls[name].value){
  //     cls += ' show';
  //   }
  //   return cls;
  // }

  // getControlName(control:FormControl):string{
  //   var controlName = null;
  //   var parent = control["_parent"];

  //   // only such parent, which is FormGroup, has a dictionary 
  //   // with control-names as a key and a form-control as a value
  //   if (parent instanceof FormGroup)
  //   {
  //       // now we will iterate those keys (i.e. names of controls)
  //       Object.keys(parent.controls).forEach((name) =>
  //       {
  //           // and compare the passed control and 
  //           // a child control of a parent - with provided name (we iterate them all)
  //           if (control === parent.controls[name])
  //           {
  //               // both are same: control passed to Validator
  //               //  and this child - are the same references
  //               controlName = name;
  //           }
  //       });
  //   }
  //   // we either found a name or simply return null
  //   return controlName;
    
  // }
  // getRegionName(job:Job):string{

  //   var valid = false;
  //   let idx = 1;
  //   var name = `${job.campaignRegions[0].name}${this.JOB_SUFFIX}`
  //   while(!valid){      
  //     // loop through the other jobs to make sure it's unique
  //     let hit = this.jobs.find(val => val.campaignRegions[0].name === `${name}`);  
      
  //     if(hit){
  //       name = `${job.campaignRegions[0].name}${this.JOB_SUFFIX}_${idx}`;
  //       ++idx;
  //     } else {
  //       valid = true;
  //     } 
  //   }
    
  //   return name;    
  // }

  onSubmit(){
    var jobs = [];
    if(this.jobs != undefined){
    this.jobs.forEach(job => {
      // const cb = `${job.uuid}_cb`;
      // const name = `${job.uuid}_name`;
      // if(this.options.controls[name].value && this.options.controls[cb].value){
        let tmpJob = new Job();
        tmpJob.uuid = job.uuid;
        // tmpJob.name = this.options.controls[name].value;
        tmpJob.name = job.campaignRegions[0].name;
        jobs.push(tmpJob);
      // }
      
    })
  } else if (this.data.job.jobs) {
    this.data.job.jobs.forEach(job => {
      // const cb = `${job.uuid}_cb`;
      // const name = `${job.uuid}_name`;
      // if(this.options.controls[name].value && this.options.controls[cb].value){
        let tmpJob = new Job();
        tmpJob.uuid = job.uuid;
        // tmpJob.name = this.options.controls[name].value;
        tmpJob.name = job.campaignRegions[0].name;
        jobs.push(tmpJob);
      // }
      
    })
  }

    let project = this.prepareSaveProject();
    const payload = {project:project,jobs:jobs,includeOffers:this.options.controls['includeOffers'].value, includeTeams:this.options.controls['includeTeams'].value};
    this.store.dispatch(new CopyFullJob(payload));
    
  }

  prepareSaveProject(): Project {
    const formModel = this.options.value;
    const saveProject: Project = new Project();
    saveProject.uuid = this.project.uuid;
    saveProject.code = formModel.code;
    saveProject.name = formModel.name as string;
    saveProject.startDate = formModel.startDate as number;
    saveProject.endDate = formModel.endDate as number;

    return saveProject;
  }

  validateProject():void{
    const formModel = this.options.value;
    let project = new Project();
    project.uuid = this.project.uuid;
    project.code = formModel.code;
    const payload = {project:project};
    this.store.dispatch(new ValidateProject(payload));
  }

  // searchProjects():void{
  //   let searchCriteria = new ProjectSearchCriteria();
  //   searchCriteria.keyword = this.searchCriteria?this.searchCriteria.keyword:'';
  //   const payload = {searchCriteria: this.searchCriteria};

  //   this.store.dispatch(new GetProjects(payload));
  // }

  close():void{

  }

  ngOnDestroy():void{
  this.jobStoreSubscription.unsubscribe();
  this.storeProjectSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/copy-dialog/copy-dialog.component.ts